"use strict";

(function () {
  'use strict';

  angular.module('app.views', ['view.dashboard', 'view.login', 'view.trips', 'view.account']).config(['$urlRouterProvider', function ($urlRouterProvider) {
    $urlRouterProvider.otherwise('/');
  }]);
})();